import { graphql, useStaticQuery } from 'gatsby';

const useSiteMetadata = () => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            siteTitle
            siteUrl
            envStage
          }
        }
      }
    `
  );
  return site.siteMetadata;
};

export default useSiteMetadata;
